import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { Job } from '@agent-ds/shared/interfaces';
import { JOB_AZ_CHECK_CONSULTING_INFO_DYNAMIC_DATA_KEY, JobAzCheckConsultingInfo, JobAzCheckTiming } from '@agent-ds/shared/interfaces/job-az-check';
import { JobApiService } from '@agent-ds/shared/services';
import { Component } from '@angular/core';

@Component({
  selector: 'ag-job-az-check-consultation-result-dialog',
  templateUrl: './job-az-check-consultation-result-dialog.component.html',
  styleUrls: ['./job-az-check-consultation-result-dialog.component.scss'],
})
export class JobAzCheckConsultationResultDialogComponent {
  job: Job;
  savedTiming: JobAzCheckTiming;
  consultingInfo: JobAzCheckConsultingInfo;
  resultDescription: string;

  constructor(
    public dialog: DialogRef,
    public config: DialogConfig<{ job: Job; savedTiming: JobAzCheckTiming }>,
    private jobApiService: JobApiService,
  ) {
    if (!config.data || !config.data.job || !config.data.savedTiming) {
      this.dialog.close();
      return;
    }

    this.job = config.data.job;
    this.savedTiming = config.data.savedTiming;
    this.consultingInfo = this.getCurrentConsultingInfo();
    this.resultDescription = '';
  }

  close(): void {
    this.dialog.close();
  }

  save(accepted: boolean): void {
    this.jobApiService.saveConsultingResult(this.job.id, {
      savedTiming: this.savedTiming,
      middlePermissionFlg: accepted ? 1 : 0,
      resultDescription: this.resultDescription,
    }).subscribe(
      () => {
        this.jobApiService.refreshEvent.emit();
        this.dialog.close();
      },
    );
  }

  private getCurrentConsultingInfo(): JobAzCheckConsultingInfo {
    const source: JobAzCheckConsultingInfo | undefined =
      this.job.dynamicData[JOB_AZ_CHECK_CONSULTING_INFO_DYNAMIC_DATA_KEY[this.savedTiming]];

    return {
      savedTiming: this.savedTiming,
      selectedJobCategory: source ? source.selectedJobCategory : null,
      contactMessage: source ? source.contactMessage : '',
      consultingItems: source ? source.consultingItems : {},
      middlePermissionFlg: source ? source.middlePermissionFlg : null,
      resultDescription: source ? source.resultDescription : '',
    };
  }
}
